// extracted by mini-css-extract-plugin
module.exports = {"ant-advanced-search-form":"PersonMng_ant-advanced-search-form__3qgCY","PersonMng":"PersonMng_PersonMng__ICebb"};